/* SimplyActive colour quiz engine. Loaded as a real asset because this theme's
   layout never includes Shopify's bundled {% javascript %} file. */
(function(){
  function boot(){
  var root = document.querySelector('[data-sa-cq]');
  if (!root || root.dataset.cqReady) return;
  root.dataset.cqReady = '1';

  var IMG = {}, HEX = {}, CFG = {};
  try { IMG = JSON.parse(root.querySelector('[data-cq-images]').textContent); } catch(e){}
  try { HEX = JSON.parse(root.querySelector('[data-cq-colours]').textContent); } catch(e){}
  try { CFG = JSON.parse(root.querySelector('[data-cq-config]').textContent); } catch(e){}

  var stage = root.querySelector('[data-cq-stage]');
  var barwrap = root.querySelector('[data-cq-barwrap]');
  var formhost = root.querySelector('[data-cq-formhost]');
  var SUB_KEY = 'sa_cq_subscribed';
  var SUB_AT = 'sa_cq_subscribed_at';
  var SEASON_KEY = 'sa_cq_season';
  var SUB_TTL = 60 * 24 * 60 * 60 * 1000;

  function subscribed(){
    try {
      if (localStorage.getItem(SUB_KEY) !== '1') return false;
      var at = parseInt(localStorage.getItem(SUB_AT) || '0', 10);
      if (at && Date.now() - at > SUB_TTL) return false;
      return true;
    } catch(e){ return false; }
  }
  function remember(){
    try { localStorage.setItem(SUB_KEY, '1'); localStorage.setItem(SUB_AT, String(Date.now())); } catch(e){}
  }
  function stash(k){ try { sessionStorage.setItem(SEASON_KEY, k); } catch(e){} }
  function unstash(){ try { return sessionStorage.getItem(SEASON_KEY); } catch(e){ return null; } }

  var Q = [
    { key:'undertone', img:'undertone', title:'Does your skin lean warm or cool?',
      hint:'Look at the veins on your inner wrist in daylight. Green looks warm, blue or purple looks cool.',
      opts:[
        {t:'Warm — golden, peachy or honey', v:'warm'},
        {t:'Cool — pink, red or blue', v:'cool'},
        {t:'Olive — a green or grey cast', v:'olive'},
        {t:'Neutral — a mix of both', v:'neutral'}
      ]},
    { key:'skin', img:'depth', title:'How deep is your skin tone?',
      hint:'Your natural tone, not a tan. Pick the closest.',
      opts:[
        {t:'Porcelain — very fair', v:'porcelain'},
        {t:'Fair', v:'fair'},
        {t:'Light to medium', v:'lightmed'},
        {t:'Medium to tan', v:'tan'},
        {t:'Deep brown', v:'deep'},
        {t:'Rich deep brown', v:'richdeep'}
      ]},
    { key:'hair', img:'hair', title:'What is your natural hair colour?',
      hint:'Undyed, in daylight.',
      opts:[
        {t:'Light blonde', v:'light'},
        {t:'Golden or strawberry blonde', v:'warmlight'},
        {t:'Light or ash brown', v:'coolmid'},
        {t:'Rich or golden brown', v:'warmmid'},
        {t:'Red, copper or auburn', v:'warmdeep'},
        {t:'Dark brown or black', v:'deep'},
        {t:'Grey or silver', v:'cool'}
      ]},
    { key:'eyes', img:'eyes', title:'What colour are your eyes?',
      hint:'Pick the closest match.',
      opts:[
        {t:'Light blue, grey or soft green', v:'coollight'},
        {t:'Warm green, hazel or golden brown', v:'warm'},
        {t:'Deep teal or cool green', v:'cool'},
        {t:'Medium or soft brown', v:'neutral'},
        {t:'Dark brown or almost black', v:'deep'},
        {t:'Bright blue or jewel green', v:'bright'}
      ]},
    { key:'jewellery', img:'jewellery', title:'Which jewellery suits you more?',
      hint:'Which one makes your skin look healthier, not washed out?',
      opts:[
        {t:'Gold — it warms my skin', v:'warm'},
        {t:'Silver — it brightens my skin', v:'cool'},
        {t:'Both look good on me', v:'neutral'}
      ]},
    { key:'contrast', img:'contrast', title:'How much do your hair and eyes stand out against your skin?',
      hint:'Squint at a photo of yourself. Does it all blur together, or do your hair and eyes jump out?',
      opts:[
        {t:'Not much — they are close to my skin tone', v:'low'},
        {t:'A fair bit — there is clear definition', v:'medium'},
        {t:'A lot — they are much deeper than my skin', v:'high'}
      ]},
    { key:'bright', img:'bright', title:'How do bright, clear colours look on you?',
      hint:'Think of a vivid red or a bright cobalt blue next to your face.',
      opts:[
        {t:'They make me pop — I look vibrant', v:'bright'},
        {t:'They overpower me — softer, muted shades suit me better', v:'muted'}
      ]}
  ];

  var NEUTRALS = ['ink', 'ash', 'oat', 'cream'];
  function pickCount(){ return window.innerWidth < 750 ? 5 : 6; }
  function shadeCount(){ return pickCount() + NEUTRALS.length; }

  var SEASONS = {
    'bright-spring': {name:'Bright Spring', why:'Warm and clear. Vivid shades with a golden edge lift you, and muted greys drain you.', colours:['cherry','amber','honey','blush','mist','sage']},
    'warm-spring':   {name:'Warm Spring',   why:'Warm and fresh. Golden, sunlit colours suit you best.', colours:['honey','amber','blush','sage','mocha','cherry']},
    'light-spring':  {name:'Light Spring',  why:'Light and warm. Soft, gentle shades with a golden edge flatter you.', colours:['blush','honey','mist','sage','amber','taro']},
    'light-summer':  {name:'Light Summer',  why:'Light and cool. Soft, airy shades suit you, deep and heavy colours overwhelm.', colours:['mist','blush','taro','sage','cherry','mocha']},
    'cool-summer':   {name:'Cool Summer',   why:'Cool and soft. Blue-based shades with a dusty finish look best on you.', colours:['mist','taro','blush','sage','cherry','mocha']},
    'soft-summer':   {name:'Soft Summer',   why:'Muted and cool. Dusty, blended shades suit you, bright ones feel harsh.', colours:['taro','mist','sage','mocha','blush','cherry']},
    'soft-autumn':   {name:'Soft Autumn',   why:'Muted and warm. Earthy, gentle shades sit beautifully on you.', colours:['sage','mocha','honey','blush','amber','mist']},
    'warm-autumn':   {name:'Warm Autumn',   why:'Warm and rich. Spice and earth tones are your strongest colours.', colours:['mocha','amber','honey','sage','cherry','blush']},
    'deep-autumn':   {name:'Deep Autumn',   why:'Deep and warm. Rich, dark shades with warmth in them suit you best.', colours:['mocha','cherry','amber','sage','honey','taro']},
    'deep-winter':   {name:'Deep Winter',   why:'Deep and cool. Strong, dark shades with a cool edge look striking on you.', colours:['cherry','taro','mist','mocha','blush','amber']},
    'cool-winter':   {name:'Cool Winter',   why:'Cool and crisp. Icy, blue-based shades are your best friends.', colours:['mist','taro','cherry','blush','mocha','sage']},
    'bright-winter': {name:'Bright Winter', why:'Cool and clear. High-contrast shades make your features pop.', colours:['cherry','mist','taro','amber','blush','honey']}
  };

  var answers = {}, step = -1, seasonKey = null, shownShades = null, shownCount = 0;

  function score(){
    var s = {}; Object.keys(SEASONS).forEach(function(k){ s[k] = 0; });
    function add(keys, n){ keys.forEach(function(k){ s[k] += n; }); }
    var warmSeasons = ['bright-spring','warm-spring','light-spring','soft-autumn','warm-autumn','deep-autumn'];
    var coolSeasons = ['light-summer','cool-summer','soft-summer','deep-winter','cool-winter','bright-winter'];

    if (answers.undertone === 'warm') add(warmSeasons, 3);
    if (answers.undertone === 'cool') add(coolSeasons, 3);
    if (answers.undertone === 'neutral') add(['soft-autumn','soft-summer','light-spring','light-summer'], 2);
    if (answers.undertone === 'olive') add(['soft-autumn','warm-autumn','soft-summer','deep-autumn'], 3);

    if (answers.jewellery === 'warm') add(warmSeasons, 2);
    if (answers.jewellery === 'cool') add(coolSeasons, 2);

    var sk = answers.skin;
    if (sk === 'porcelain') add(['light-spring','light-summer','cool-summer','bright-winter'], 3);
    if (sk === 'fair') add(['light-spring','light-summer','warm-spring','cool-summer'], 3);
    if (sk === 'lightmed') { add(['warm-spring','cool-summer','soft-summer','bright-spring'], 2); add(['light-spring','light-summer'], 1); }
    if (sk === 'tan') { add(['soft-autumn','warm-autumn','bright-spring','soft-summer'], 3); add(['deep-autumn'], 1); }
    if (sk === 'deep') { add(['deep-autumn','deep-winter','warm-autumn','bright-winter'], 3); add(['cool-winter'], 2); }
    if (sk === 'richdeep') { add(['deep-winter','deep-autumn','bright-winter','cool-winter'], 3); }

    if (answers.contrast === 'low') add(['soft-summer','soft-autumn','light-summer','light-spring'], 2);
    if (answers.contrast === 'medium') add(['cool-summer','warm-autumn','warm-spring','deep-autumn'], 2);
    if (answers.contrast === 'high') add(['bright-winter','deep-winter','bright-spring','cool-winter'], 2);

    if (answers.bright === 'bright') add(['bright-spring','bright-winter','cool-winter','warm-spring','deep-winter'], 3);
    if (answers.bright === 'muted') add(['soft-summer','soft-autumn','light-summer','warm-autumn'], 3);

    var h = answers.hair;
    if (h === 'light') add(['light-spring','light-summer'], 2);
    if (h === 'warmlight') add(['warm-spring','light-spring'], 2);
    if (h === 'coolmid') add(['cool-summer','soft-summer','light-summer'], 2);
    if (h === 'warmmid') add(['warm-autumn','soft-autumn'], 2);
    if (h === 'warmdeep') add(['warm-autumn','deep-autumn'], 3);
    if (h === 'deep') add(['deep-winter','deep-autumn','bright-winter'], 2);
    if (h === 'cool') add(['cool-winter','cool-summer'], 2);

    var e = answers.eyes;
    if (e === 'coollight') add(['light-summer','cool-summer'], 2);
    if (e === 'warm') add(['warm-autumn','warm-spring','soft-autumn'], 2);
    if (e === 'cool') add(['cool-winter','cool-summer'], 2);
    if (e === 'neutral') add(['soft-summer','soft-autumn'], 2);
    if (e === 'deep') add(['deep-winter','deep-autumn'], 2);
    if (e === 'bright') add(['bright-winter','bright-spring'], 3);

    var best = null;
    Object.keys(s).forEach(function(k){ if (!best || s[k] > s[best]) best = k; });
    return best;
  }

  function progress(){
    barwrap.hidden = step < 0;
    if (step < 0) return;
    var pct = Math.round((step / Q.length) * 100);
    root.querySelector('[data-cq-step]').textContent = step < Q.length ? ('Question ' + (step + 1) + ' of ' + Q.length) : 'Your palette';
    root.querySelector('[data-cq-pct]').textContent = (step < Q.length ? pct : 100) + '%';
    root.querySelector('[data-cq-fill]').style.width = (step < Q.length ? pct : 100) + '%';
  }

  function esc(t){ return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function cap(c){ return c.charAt(0).toUpperCase() + c.slice(1); }

  function shuffle(list){
    var a = list.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function buildShades(s){
    shownCount = shadeCount();
    return shuffle(s.colours.slice(0, pickCount()).concat(NEUTRALS));
  }

  function paletteUrl(colours){
    return '/collections/all?' + colours.map(function(c){
      return 'filter.v.option.color=' + encodeURIComponent(cap(c));
    }).join('&');
  }

  function chips(list){
    return list.map(function(c){
      return '<a class="sa-cq__chip" href="/collections/' + c + '"><span class="sa-cq__chipc" style="background:' + (HEX[c] || '#ddd') + '"></span><span class="sa-cq__chipn">' + cap(c) + '</span></a>';
    }).join('');
  }

  function renderQ(){
    var q = Q[step], src = IMG[q.img];
    stage.innerHTML = '<div class="sa-cq__q">' +
      (src ? '<img class="sa-cq__qimg" src="' + esc(src) + '" alt="" loading="lazy">' : '') +
      '<h2>' + esc(q.title) + '</h2>' +
      (q.hint ? '<p class="sa-cq__hint">' + esc(q.hint) + '</p>' : '') +
      '<div class="sa-cq__opts">' + q.opts.map(function(o){
        var on = answers[q.key] === o.v ? ' is-on' : '';
        return '<button type="button" class="sa-cq__opt' + on + '" data-cq-pick="' + esc(o.v) + '">' + esc(o.t) + '</button>';
      }).join('') + '</div>' +
      '<div class="sa-cq__nav"><button type="button" class="sa-cq__back" data-cq-back>&larr; Back</button>' +
      '<button type="button" class="sa-cq__btn" data-cq-next ' + (answers[q.key] ? '' : 'disabled') + '>' + (step === Q.length - 1 ? 'See my colours' : 'Continue') + '</button></div></div>';
    progress();
  }

  /* The gate must not leak the answer. Blurring the real swatches was useless:
     the hex codes still sat in the page source, so anyone could read their
     palette without handing over an email. The teaser is now placeholder discs
     with no palette data in the DOM at all, and the season name is only written
     into the form tag at submit time. */
  function renderGate(){
    var n = shadeCount();
    var discs = '';
    for (var i = 0; i < n; i++) discs += '<span class="sa-cq__peekc"></span>';
    stage.innerHTML = '<div class="sa-cq__result sa-cq__gate">' +
      '<p class="sa-cq__eyebrow">Your palette is ready</p>' +
      '<h2 class="sa-cq__gatetitle">' + esc(CFG.gate_title || 'Where shall we send it?') + '</h2>' +
      '<p class="sa-cq__why">' + esc(CFG.gate_text || 'Pop your email in and we will unlock your palette.') + '</p>' +
      '<div class="sa-cq__peek" aria-hidden="true">' + discs +
        '<span class="sa-cq__peektxt">' + n + ' shades matched to you</span></div>' +
      '<div data-cq-formslot></div>' +
      '<p class="sa-cq__note">' + esc(CFG.gate_note || 'One email, unsubscribe anytime.') + '</p>' +
      '</div>';

    var slot = stage.querySelector('[data-cq-formslot]');
    if (formhost && slot) {
      formhost.hidden = false;
      slot.appendChild(formhost);
      var inp = formhost.querySelector('input[type=email]');
      if (inp) inp.focus();
    }
    progress();
  }

  /* Season goes on the customer record, but only once they have actually
     submitted, so it is not sitting in a hidden input for anyone to read. */
  if (formhost) {
    formhost.addEventListener('submit', function(){
      var tags = formhost.querySelector('[data-cq-tags]');
      if (tags && seasonKey) tags.value = 'newsletter, colour-quiz, season-' + seasonKey;
    }, true);
  }

  function renderResult(keepOrder){
    var s = SEASONS[seasonKey];
    var shades = (keepOrder && shownShades) ? shownShades : buildShades(s);
    shownShades = shades;
    if (formhost) { formhost.hidden = true; root.appendChild(formhost); }
    stage.innerHTML = '<div class="sa-cq__result">' +
      '<p class="sa-cq__eyebrow">Your palette</p>' +
      '<h2 class="sa-cq__season">' + esc(s.name) + '</h2>' +
      '<p class="sa-cq__why">' + esc(s.why) + '</p>' +
      '<div class="sa-cq__palette">' + chips(shades) + '</div>' +
      '<p class="sa-cq__avoid">' + shades.length + ' shades that work on you, warm neutrals and all. These lift your colouring most next to your face — and black bottoms go with every one of them.</p>' +
      '<div class="sa-cq__actions">' +
        '<a class="sa-cq__btn" href="' + paletteUrl(shades) + '">Shop my palette</a>' +
        '<button type="button" class="sa-cq__btn sa-cq__btn--ghost" data-cq-restart>Start again</button>' +
      '</div>' +
      '<p class="sa-cq__note">Opens the whole shop filtered to your shades. Narrow it down by fit, activity or size from there.</p>' +
      '<div class="sa-cq__picks" data-cq-pickswrap><p class="sa-cq__pickshead">Your colours, in stock</p><div class="sa-cq__grid" data-cq-products></div></div></div>';
    progress();
    loadPicks(s.colours);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:'colour_quiz_result', season:s.name}); } catch(e){}
  }

  var resizeTimer = null;
  window.addEventListener('resize', function(){
    if (!seasonKey || !stage.querySelector('.sa-cq__palette')) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      if (shadeCount() !== shownCount) renderResult(false);
    }, 200);
  });

  function finish(){
    seasonKey = score();
    stash(seasonKey);
    if (subscribed()) renderResult(); else renderGate();
  }

  function loadPicks(colours){
    var box = stage.querySelector('[data-cq-products]');
    var wrap = stage.querySelector('[data-cq-pickswrap]');
    if (!box) return;
    Promise.all(colours.slice(0, 4).map(function(c){
      return fetch('/collections/' + c + '/products.json?limit=3').then(function(r){ return r.json(); }).catch(function(){ return { products: [] }; });
    })).then(function(sets){
      var out = [];
      sets.forEach(function(set){ (set.products || []).slice(0, 2).forEach(function(p){ out.push(p); }); });
      if (!out.length) { if (wrap) wrap.hidden = true; return; }
      box.innerHTML = out.slice(0, 6).map(function(p){
        var im = p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
        var price = p.variants && p.variants[0] ? '£' + String(p.variants[0].price).replace('.00', '') : '';
        return '<a class="sa-cq__card" href="/products/' + p.handle + '"><img src="' + im + '" alt="" loading="lazy"><span>' + esc(p.title) + '</span><span class="sa-cq__cardp">' + price + '</span></a>';
      }).join('');
    }).catch(function(){ if (wrap) wrap.hidden = true; });
  }

  function top(){ var y = root.getBoundingClientRect().top + window.pageYOffset - 90; window.scrollTo({ top: y, behavior: 'smooth' }); }

  root.addEventListener('click', function(e){
    if (e.target.closest('[data-cq-begin]')) { step = 0; renderQ(); top(); return; }
    var pick = e.target.closest('[data-cq-pick]');
    if (pick) {
      answers[Q[step].key] = pick.getAttribute('data-cq-pick');
      Array.prototype.forEach.call(stage.querySelectorAll('[data-cq-pick]'), function(b){ b.classList.toggle('is-on', b === pick); });
      var nx = stage.querySelector('[data-cq-next]');
      if (nx) nx.disabled = false;
      return;
    }
    if (e.target.closest('[data-cq-next]')) {
      if (!answers[Q[step].key]) return;
      step++;
      if (step >= Q.length) finish(); else renderQ();
      top();
      return;
    }
    if (e.target.closest('[data-cq-back]')) { step = Math.max(0, step - 1); renderQ(); top(); return; }
    if (e.target.closest('[data-cq-restart]')) { answers = {}; seasonKey = null; shownShades = null; step = 0; renderQ(); top(); return; }
  });

  var posted = CFG.posted === true || /customer_posted=true/.test(location.search);
  var saved = unstash();
  if (posted) remember();
  if (posted && saved && SEASONS[saved]) {
    seasonKey = saved;
    step = Q.length;
    renderResult();
    top();
  }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();